<template>
  <article class="repair-page">
    <header class="text-block">
      <h1>{{ section.title }}</h1>
      <p
        v-for="(paragraph, i) in descriptionParagraphs"
        v-bind:key="i"
      >{{ paragraph }}</p>
    </header>
    <div class="repair-gallery-main">
      <tagged-image-aside-slide
        v-for="(repairImage, i) in repairImages"
        v-bind:key="repairImage.id"
        v-bind:image="repairImage"
        v-bind:preferred-image-position="getPreferredImagePosition(i)"
      >
      </tagged-image-aside-slide>
    </div>
    <footer>
      <div class="text-block">
        <p>
          При оформлении квитанции мы включаем в оплату только основные
          поломки, хотя при внимательном рассмотрении мастер часто обнаруживает
          и множество других недостатков. В таком случае он устраняет их
          бесплатно. Мы никогда не выдаем заказчику изделие с дефектами, даже
          если они не были замечены сразу и не включены в оплату!
          Это наш принцип!
        </p>
        <p>
          Подавляющее большинство заказов выполняются так, что работа ювелира
          абсолютно незаметна. В нашей фирме даже самые мелкие цепи паяются
          под микроскопом так, что все звенья свободно двигаются, а место
          спайки можно заметить лишь при очень большом увеличении. Лишь в
          исключительных случаях работа остается заметной невооруженному
          глазу - и тогда мы предупреждаем об этом заранее.
        </p>
        <p>
          Доверяйте свои украшения только профессионалам! Вмешательство
          человека с низкой квалификацией может нанести ювелирному украшению
          непоправимый ущерб!
        </p>
      </div>
      <basic-contacts
        v-bind:heading="'Отремонтировать изделия можно в Бресте, наш адрес:'"
      ></basic-contacts>
    </footer>
  </article>
</template>

<script>
import BasicContacts from '../components/the-content/utils/BasicContacts'
import TaggedImageAsideSlide from '../components/the-content/utils/TaggedImageAsideSlide'
import utils from './utils'

export default {
  name: 'RepairPage',
  components: {BasicContacts, TaggedImageAsideSlide},
  data () {
    return {
      section: {},
      repairImages: [],
      title: 'Ремонт ювелирных изделий в Бресте'
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.section.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.imageForMeta.image,
        imageWidth: this.imageForMeta.width,
        imageHeight: this.imageForMeta.height
      })
    }
  },
  mounted () {
    this.getSection()
    this.getRepairImages()
  },
  updated () {
    if (Object.keys(this.section).length > 0 &&
        this.repairImages.length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    descriptionParagraphs: function () {
      return (this.section.description)
        ? this.section.description.split(/\r?\n/) : []
    },
    imageForMeta: function () {
      return (this.repairImages.length > 0) ? this.repairImages[0] : {}
    }
  },
  methods: {
    getSection: function () {
      const apiHost = process.env.API_HOST
      this.$http
        .get(`${apiHost}/api/v1/site-structure/get-section-with-categories/repair`)
        .then(response => { this.section = response.body })
    },
    getRepairImages: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      const repairTags = ['repair-page', 'repair-gallery-main']
      let uriParams = {include_tags: repairTags.join(',')}

      this.$http
        .get(uri, {params: uriParams})
        .then(response => { this.repairImages = response.body })
    },
    getPreferredImagePosition: function (slideIndex) {
      return (slideIndex % 2 === 1) ? 'right' : 'left'
    }
  }
}
</script>

<style scoped lang="scss">
  .repair-page {
    & > *, & > footer > * {
      margin-bottom: 2em !important;
      &:last-child { margin-bottom: 0 !important; }
    }
    @include page-block-vertical-padding();
    .text-block {
      @include text-block();
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/RepairPage.vue